import React, { useMemo } from 'react';
import { Skeleton } from '@mui/material';
import { filter, sortBy } from 'lodash';
import CommonPieChart from './CommonPieChart';


export default function TopicPercentageChart({ topicPercentage }) {
  const dataset = useMemo(() => {
    if (!Array.isArray(topicPercentage)) return [];
    return sortBy(
      filter(topicPercentage, (item) => item.topicPercentageInt > 0).map(
        (item) => ({
          id: item.topicName,
          label: item.topicName,
          value: item.topicPercentageInt,
        })
      ),
      'value'
    ).reverse();
  }, [topicPercentage]);


  if (!topicPercentage) {
    return <Skeleton variant="circular" width="15vw" height="15vw" />;
  }


  const bottomMargin = dataset.length <= 6 ? 5 * 28.6 : 6.5 * 28.6;


  return (
    <CommonPieChart
      title="Topics"
      data={dataset}
      height={420}
      minHeight="40vh"
      maxHeight="100vh"
      description="Distribution of content across different topics, showing which subjects resonate most with your audience."
      valueFormatter={(v) => `${v.value}%`}
      margin={{ left: 0, top: 10, right: 0, bottom: bottomMargin }}
    />
  );
}
